import { CircularProgress, Grid, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { Controller, Control, UseFormHandleSubmit } from "react-hook-form";
import { SubcontractorCostingFormValues } from "./jobPhaseCosting";

export default function SubcontractorCostingFields({
  control,
  loading,
  onSubmit,
  handleSubmit,
}: {
  control: Control<SubcontractorCostingFormValues>;
  loading: boolean;
  onSubmit: (values: SubcontractorCostingFormValues) => Promise<void>;
  handleSubmit: UseFormHandleSubmit<SubcontractorCostingFormValues>;
}) {
  return (
    <MDBox mb={4}>
      <MDTypography variant="h6" mb={2}>
        Subcontractor Actual Cost
      </MDTypography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Controller
            name="actualSubcontractorCost"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Actual Subcontractor Cost"
                type="number"
                inputProps={{ step: "0.01", min: 0 }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Controller
            name="actualSubcontractorName"
            control={control}
            render={({ field }) => (
              <TextField {...field} fullWidth size="small" label="Subcontractor Name" />
            )}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Controller
            name="actualSubcontractorReference"
            control={control}
            render={({ field }) => (
              <TextField {...field} fullWidth size="small" label="Reference / Invoice" />
            )}
          />
        </Grid>
        <Grid item xs={12} display="flex" justifyContent="flex-end">
          <MDButton
            type="button"
            variant="contained"
            color="success"
            onClick={handleSubmit(onSubmit)}
          >
            {loading ? <CircularProgress color="inherit" size={20} /> : "Save Costs"}
          </MDButton>
        </Grid>
      </Grid>
    </MDBox>
  );
}
